import { render, staticRenderFns } from "./Statistical_User.vue?vue&type=template&id=2e8286eb&scoped=true&"
import script from "./Statistical_User.vue?vue&type=script&lang=js&"
export * from "./Statistical_User.vue?vue&type=script&lang=js&"
import style0 from "./Statistical_User.vue?vue&type=style&index=0&id=2e8286eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8286eb",
  null
  
)

export default component.exports